import wx from 'weixin-js-sdk'

/**
 * 微信分享
 */
export const wxSdk = {
    /**
     * [wxSdk 微信Api初始化]
     */
    wxConfig (data) { // data是微信配置信息
        wx.config({
            debug: false, // 开启调试模式
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
                // 'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
    },

    wxShare (option) { // option是分享的配置内容
        wx.ready(function () {
            wx.onMenuShareAppMessage({
                title: option.title, // 分享标题
                desc: option.desc, // 分享描述
                link: option.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: option.imgUrl, // 分享图标
                success: function (res) {
                    // 用户点击了分享后执行的回调函数
                    console.log('点击了分享',res)
                    // alert('我点击了分享')
                }
            });
        })

        wx.error(function (res) {
            console.log('分享失败',res.errMsg)
            // alert(res.errMsg)
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
    }
}
